
const Hero = () => {
  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(16, 185, 129, 0.85) 0%, rgba(6, 78, 59, 0.9) 100%), url('https://readdy.ai/api/search-image?query=Modern%20premium%20solar%20panel%20installation%20on%20luxury%20Indian%20home%20rooftop%20with%20clear%20blue%20sky%2C%20professional%20solar%20energy%20system%2C%20high-end%20residential%20property%2C%20clean%20technology%2C%20bright%20sunlight%2C%20architectural%20excellence%2C%20contemporary%20design&width=1920&height=1080&seq=hero-solar-pro&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-6 py-20">
        <div className="w-full max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="text-white space-y-8">
              <div className="space-y-4">
                <div className="inline-flex items-center bg-amber-500/20 backdrop-blur-sm border border-amber-400/30 rounded-full px-4 py-2 text-amber-200 text-sm font-medium">
                  <i className="ri-government-line mr-2"></i>
                  PM Surya Ghar Yojana 2025 Authorized Partner
                </div>
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
                  Power Your Home with
                  <span className="block text-transparent bg-gradient-to-r from-amber-300 to-yellow-400 bg-clip-text">
                    Clean Solar Energy
                  </span>
                </h1>
                <p className="text-xl md:text-2xl text-emerald-100 leading-relaxed max-w-2xl">
                  Transform your electricity bills into savings with India's most trusted solar solutions. 
                  Get up to <strong className="text-amber-300">₹78,000 government subsidy</strong> and start 
                  generating your own power today.
                </p>
              </div>

              <div className="flex flex-wrap gap-6 text-emerald-100">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-emerald-500/20 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-shield-check-line text-emerald-300 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold">Guaranteed Subsidy</div>
                    <div className="text-sm opacity-90">100% Assistance</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-money-rupee-circle-line text-amber-300 text-xl"></i>
                  </div>
                  <div>
                    <div className="font-semibold">Save up to 80%</div>
                    <div className="text-sm opacity-90">On Electricity Bills</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <a 
                  href="#plans" 
                  className="group bg-gradient-to-r from-emerald-500 to-emerald-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-emerald-600 hover:to-emerald-700 transition-all duration-300 text-center whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  <span className="flex items-center justify-center">
                    Explore Solar Plans
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </a>
                <a 
                  href="tel:7496038344" 
                  className="group bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-emerald-600 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                >
                  <span className="flex items-center justify-center">
                    <i className="ri-phone-line mr-2"></i>
                    Free Consultation
                  </span>
                </a>
              </div>
            </div>

            {/* Right Stats */}
            <div className="lg:flex hidden flex-col space-y-6">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 text-white">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-emerald-400 to-emerald-500 rounded-full flex items-center justify-center">
                    <i className="ri-home-smile-line text-white text-xl"></i>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-bold text-emerald-300">10,000+</div>
                    <div className="text-sm opacity-90">Happy Customers</div>
                  </div>
                </div>
                <div className="text-emerald-100">Homes powered across Haryana</div>
              </div>

              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 text-white">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full flex items-center justify-center">
                    <i className="ri-money-rupee-circle-line text-white text-xl"></i>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-bold text-amber-300">₹78,000</div>
                    <div className="text-sm opacity-90">Max Subsidy</div>
                  </div>
                </div>
                <div className="text-amber-100">Government support available</div>
              </div>

              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 text-white">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-blue-500 rounded-full flex items-center justify-center">
                    <i className="ri-leaf-line text-white text-xl"></i>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl font-bold text-blue-300">25 Years</div>
                    <div className="text-sm opacity-90">Warranty</div>
                  </div>
                </div>
                <div className="text-blue-100">Long-term reliability guaranteed</div>
              </div>
            </div>
          </div>

          {/* Bottom Trust Indicators */}
          <div className="mt-16 pt-8 border-t border-white/20">
            <div className="flex flex-wrap items-center justify-center gap-8 text-white/80">
              <div className="flex items-center space-x-2">
                <i className="ri-award-line text-amber-400"></i>
                <span className="text-sm font-medium">Authorized Partner</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-line text-emerald-400"></i>
                <span className="text-sm font-medium">Certified Installation</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-line text-blue-400"></i>
                <span className="text-sm font-medium">Mon - Sat: 10 AM - 5 PM</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-bank-card-line text-purple-400"></i>
                <span className="text-sm font-medium">Flexible EMI</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 right-10 w-20 h-20 bg-amber-400/20 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute bottom-32 left-10 w-16 h-16 bg-emerald-400/20 rounded-full blur-xl animate-pulse delay-1000"></div>
    </section>
  );
};

export default Hero;
